import React from 'react'

import LoginScreen from '../screens/Login'
import SignUpScreen from '../screens/SignUp'

import ProfileScreen from '../screens/ProfileScreen'
import HomeScreen from '../screens/HomeScreen'
import CombinedCalendarScreen from '../screens/CombinedCalendarScreen'

import WorkspaceCalendarScreen from '../screens/WorkspaceCalendarScreen'
import WorkspaceDocumentRepositoryScreen from '../screens/WorkspaceDocumentRepositoryScreen'
import WorkspaceCalendarEventScreen from '../screens/WorkspaceCalendarEventScreen'
import WorkspaceRepeatingEventScreen from '../screens/WorkspaceRepeatingEventScreen'

import ManageTeamScreen from '../screens/ManageTeam'
import ManageCalendarScreen from '../screens/ManageCalendar'
import InvitationScreen from '../screens/Invitation'
import DetailsScreen from '../screens/Details'

import SearchBusinessesScreen from '../screens/SearchBusinesses'
import RegisterBusinessScreen from '../screens/RegisterBusiness'
import RegisterBusinessSetupScreen from '../screens/RegisterBusinessSetup'
import SignDocumentScreen from '../screens/SignDocumentScreen'

interface RouteType {
  path: string
  component: React.ComponentType<object>
  name: string
  protected: boolean
}

const routes: RouteType[] = [
  {
    path: '/',
    component: HomeScreen,
    name: 'Home',
    protected: true,
  },
  {
    path: '/profile',
    component: ProfileScreen,
    name: 'Profile',
    protected: true,
  },
  {
    path: '/calendar',
    component: CombinedCalendarScreen,
    name: 'Calendar',
    protected: true,
  },
  {
    path: '/new-business',
    component: SearchBusinessesScreen,
    name: 'Find your business',
    protected: true,
  },
  {
    path: '/new-business/:companyNumber',
    component: RegisterBusinessScreen,
    name: 'Register business',
    protected: true,
  },
  {
    path: '/setup-business/:businessId',
    component: RegisterBusinessSetupScreen,
    name: 'Configure business',
    protected: true,
  },
  {
    path: '/workspace/:workspaceId/calendar',
    component: WorkspaceCalendarScreen,
    name: 'Dashboard',
    protected: true,
  },
  {
    path: '/workspace/:workspaceId/calendar/event/:eventId',
    component: WorkspaceCalendarEventScreen,
    name: 'Event',
    protected: true,
  },
  {
    path: '/workspace/:workspaceId/manage-events',
    component: ManageCalendarScreen,
    name: 'Manage events',
    protected: true,
  },
  {
    path: '/workspace/:workspaceId/manage-events/:repeatingEventId',
    component: WorkspaceRepeatingEventScreen,
    name: 'Repeating event',
    protected: true,
  },
  {
    path: '/workspace/:workspaceId/documents',
    component: WorkspaceDocumentRepositoryScreen,
    name: 'Documents',
    protected: true,
  },
  {
    path: '/workspace/:workspaceId/documents/:documentId/sign',
    component: SignDocumentScreen,
    name: 'Sign document',
    protected: true,
  },
  {
    path: '/workspace/:workspaceId/details',
    component: DetailsScreen,
    name: 'Business details',
    protected: true,
  },
  {
    path: '/workspace/:workspaceId/team',
    component: ManageTeamScreen,
    name: 'Manage team',
    protected: true,
  },
  {
    path: '/invitation/:invitationId',
    component: InvitationScreen,
    name: 'Invitation',
    protected: true,
  },
  {
    path: '/login',
    component: LoginScreen,
    name: 'Login',
    protected: false,
  },
  {
    path: '/sign-up',
    component: SignUpScreen,
    name: 'Sign Up',
    protected: false,
  },
]

export default routes
